module.exports = __webpack_public_path__ + "static/assets/14527e39e3bb437ed1d580b612bab90a.png";